export type CicBucket = "bond" | "equity" | "cash" | "derivative" | "unknown";

const CIC_SUFFIX_LENGTH = 2;
const CIC_CASH_SUFFIX_MIN = 71;
const CIC_CASH_SUFFIX_MAX = 79;
const CIC_EQUITY_SUFFIX_MIN = 30;
const CIC_EQUITY_SUFFIX_MAX = 39;
const CIC_BOND_SUFFIX_MIN = 11;
const CIC_BOND_SUFFIX_MAX = 29;
const CIC_STRUCTURED_NOTE_SUFFIX_MIN = 51;
const CIC_STRUCTURED_NOTE_SUFFIX_MAX = 59;
const CIC_COLLATERALISED_SUFFIX_MIN = 61;
const CIC_COLLATERALISED_SUFFIX_MAX = 69;

function isBondSuffix(suffixValue: number): boolean {
    return (
        (suffixValue >= CIC_BOND_SUFFIX_MIN && suffixValue <= CIC_BOND_SUFFIX_MAX) ||
        (suffixValue >= CIC_STRUCTURED_NOTE_SUFFIX_MIN && suffixValue <= CIC_STRUCTURED_NOTE_SUFFIX_MAX) ||
        (suffixValue >= CIC_COLLATERALISED_SUFFIX_MIN && suffixValue <= CIC_COLLATERALISED_SUFFIX_MAX)
    );
}

function cicSuffix(cic: unknown): string {
    if (cic === null || typeof cic === "undefined") {
        return "";
    }
    const normalized = String(cic).trim().toUpperCase().replace(/\s/g, "");
    if (!normalized || ["NAN", "NONE", "NAT"].includes(normalized)) {
        return "";
    }
    if (normalized.length < CIC_SUFFIX_LENGTH) {
        return "";
    }
    return normalized.slice(-CIC_SUFFIX_LENGTH);
}

export function cicBucket(cic: unknown): CicBucket {
    const suffix = cicSuffix(cic);
    if (!suffix) {
        return "unknown";
    }
    if (/[A-Z]/i.test(suffix)) {
        return "derivative";
    }
    if (!/^\d+$/.test(suffix)) {
        return "unknown";
    }
    const numericSuffix = Number(suffix);
    if (numericSuffix >= CIC_CASH_SUFFIX_MIN && numericSuffix <= CIC_CASH_SUFFIX_MAX) {
        return "cash";
    }
    if (numericSuffix >= CIC_EQUITY_SUFFIX_MIN && numericSuffix <= CIC_EQUITY_SUFFIX_MAX) {
        return "equity";
    }
    if (isBondSuffix(numericSuffix)) {
        return "bond";
    }
    return "unknown";
}

export function assetCategoryFromCic(cic: string): string {
    const trimmed = cic.trim();
    if (trimmed.length < 3) {
        return "";
    }
    return trimmed[2];
}
